import { render, staticRenderFns } from "./DetalleVentas.vue?vue&type=template&id=db1fb9e8&scoped=true&"
import script from "./DetalleVentas.vue?vue&type=script&lang=js&"
export * from "./DetalleVentas.vue?vue&type=script&lang=js&"
import style0 from "./DetalleVentas.vue?vue&type=style&index=0&id=db1fb9e8&lang=scss&scoped=true&"
import style1 from "./DetalleVentas.vue?vue&type=style&index=1&id=db1fb9e8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1fb9e8",
  null
  
)

export default component.exports